import styled from "styled-components"

export const Content = styled.div`
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  color: var(--text-body);
`;